/**
 * The ONE rule for "sold as a stone slab" — its pieces, layout, seams, edges,
 * cutouts, its stone type, and the catalog import's size check all ask it. It
 * lives in `labor/qualifiers.js`, which reads a slab's stone type and may not
 * import `estimate-pricing`; re-exported here for everything that always
 * required it from here.
 */
const { isSlabFinish } = require('../../labor/qualifiers');

module.exports = { isSlabFinish };
